import { Collection } from 'modules/core/lib/mobx-rest'

import TemplateVariable from 'modules/documents/store/models/FieldVariable'

class FieldVariables extends Collection<TemplateVariable> {
  get cacheKey(): string {
    return 'fieldVariables'
  }

  model() {
    return TemplateVariable
  }

  // Model not coming from database so need to define primary key
  get primaryKey(): string {
    return 'variable'
  }
}

const singleton: FieldVariables = new FieldVariables()

export default singleton
